import React, { CSSProperties, FC } from 'react';

import { Typography } from '../Typography/Typography';
import LogoSVG from './Logo.svg';
import NoWordingLogoSVG from './NoWordingLogo.svg';

interface AppLogoProps {
  readonly isNoWording?: boolean;
  readonly style?: CSSProperties;
  readonly className?: string;
}

export const Logo: FC<AppLogoProps> = ({ isNoWording, style, className }) => (
  <Typography.Body className={className} style={style}>
    {isNoWording ? <NoWordingLogoSVG /> : <LogoSVG />}
  </Typography.Body>
);
